import { css } from '@emotion/react';

export const styPopupContentContainer = css({
  display: 'flex',
  gap: 33,
  flexDirection: 'column',
  height: '100%',
  padding: 30,
});

export const styButtonCustomDomain = css({
  padding: '10px 18px !important',
  width: '221px',
  borderRadius: 8,
  fontSize: 16,
  fontWeight: 600,
  letterSpacing: -0.16,
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  backgroundColor: '#17151B',
  borderColor: 'transparent',
});

export const styBgImageHeader = css({
  borderRadius: 999,
  background: '#FFD2D2',
  width: 121,
  height: 121,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
});

export const styTwitterBoxHeader = css({ fontSize: 14, fontWeight: 700 });

export const styTwitterBoxContent = css({ width: 401, fontSize: 13, fontWeight: 500, height: 60 });

export const styLink = css({ color: '#5291EA' });

export const styTextPopupHeader = css({
  maxWidth: '413px',
  textAlign: 'center',
  fontSize: 32,
  fontWeight: 600,
  lineHeight: '44px',
  letterSpacing: '-0.64px',
  flexDirection: 'column',
  alignSelf: 'center',
  color: 'var(--text-twitter-popup)',
});

export const styButtonTweet = css({
  alignSelf: 'flex-end',
  fontSize: 12,
  fontWeight: 700,
  color: 'white',
  borderRadius: 43,
  background: '#528EF2',
  padding: '4px 9px',
  pointerEvents: 'fill',
  cursor: 'pointer',
});

export const styBigBoxContentContainer = css({
  display: 'flex',
  gap: 11,
});

export const styBgTwitterIcon = css({
  width: 33,
  height: 33,
  borderRadius: '50%',
  backgroundColor: 'white',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0px 5.712643623352051px 14.281608581542969px 0px rgba(0, 0, 0, 0.08)',
});
export const styBoxSiteUrl = css({
  width: 361,
  height: 72,
  borderRadius: 20,
  display: 'flex',
  padding: '24px 21px',
  justifyContent: 'center',
  alignContent: 'center',
  alignSelf: 'center',
  background: 'var(--color-background)',
  boxShadow: '0px 17px 44px -22px rgba(88, 87, 89, 0.19)',
  position: 'relative',

  '::before': {
    borderRadius: 20,
    content: '""',
    backgroundImage: 'linear-gradient(245.99deg, #F6F4FA 11.87%, #EBE8F3 70.03%)',
    top: -1,
    left: -1,
    bottom: -1,
    right: -1,
    position: 'absolute',
    zIndex: -1,
  },
});

export const styTextUrl = css({
  maxWidth: '280px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  fontSize: 14.71,
  fontWeight: 600,
  letterSpacing: -0.368,
  marginLeft: 8,
});

export const styBigBoxBottomContainer = css({
  display: 'flex',
  flexDirection: 'column',
  width: 472,
  height: 147,
  padding: '19px 11px 13px 19px',
  backgroundColor: 'var(--background-tweet)',
  borderRadius: 17,
});

export const styBottomContainer = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: 84,
});
export const styButtonBottomContainer = css({
  display: 'flex',
  gap: 20,
});

export const styTextNextStep = css({
  fontSize: 18,
  fontWeight: 700,
});

export const styLearnMore = css({
  alignSelf: 'center',

  color: 'var(--color-text-text-secondary, #929CAD)',
  fontSize: 13,
  fontWeight: 600,
});
